<template>
	<div>
		<md-content>
			 <div class="md-layout md-gutter">
					<div class="md-layout-item md-xsmall-size-25">
						<md-button class="md-raised " @click.native="goBack">返回</md-button>
					</div>
			 </div>		
			<div class="md-layout md-gutter">
		       <div class="md-layout-item md-xsmall-size-100">
			      	<md-field>
				      <label>产品名称</label>
				      <md-input v-model="pdata.issued_app_name" disabled="disabled"></md-input>
				    </md-field>
		       </div>
		        <div class="md-layout-item md-xsmall-size-50">
			      	<md-datepicker v-model="pdata.sdate" value="string" />
			
		       </div>
		       <div class="md-layout-item md-xsmall-size-50">
			      	<md-datepicker v-model="pdata.edate" value="string" />
		
		       </div>
		    </div> 
		    
		    <div class="md-layout md-gutter"> 
		    	
			     <div class="md-layout-item md-xsmall-size-50"> 
			     	    <md-card md-with-hover>
					      <md-ripple>
					        <md-card-header>
					          <div class="md-title">{{c2data.total.jump_per}}%</div>
					          <div class="md-subhead">跳出率</div>
					        </md-card-header>
					      </md-ripple>
					    </md-card>
			     </div> 
			     <div class="md-layout-item md-xsmall-size-50"> 
			     	    <md-card md-with-hover>
					      <md-ripple>
					        <md-card-header>
					          <div class="md-title">{{c2data.total.click_per}}%</div>
					          <div class="md-subhead">创意点击确认率</div>
					        </md-card-header>
					      </md-ripple>
					    </md-card>
			     </div> 
		    </div> 
		    
		    <div class="md-layout md-gutter"> 
		    	<h3 class="md-layout-item md-xsmall-size-100">屏蔽策略</h3>
		    	 <div class="md-layout md-gutter">
					<div class="md-layout-item md-xsmall-size-25">
						<md-button class="md-raised" @click.native="addProduct">新增</md-button>
					</div>
					<div class="md-layout-item md-xsmall-size-25">
						<md-button class="md-raised " @click="changeStatus(false,1)">启用</md-button>
					</div>
					<div class="md-layout-item md-xsmall-size-25">
						<md-button class="md-raised md-accent"  @click="changeStatus(false,0)">禁用</md-button>
					</div>
					<!--<div class="md-layout-item md-xsmall-size-25">
						<md-button class="md-raised md-accent">删除</md-button>
					</div>-->
	    		</div>
	    		<div class="md-layout-item md-xsmall-size-100">
			     	<md-table v-model="rlist" v-if="rlist.length>0"  @md-selected="onRSelect"> 
						
				     	<md-table-row  slot="md-table-row" slot-scope="{ item }"  md-selectable="multiple" md-auto-select>
					        <md-table-cell md-label="ID"  md-numeric> {{ item.id }}</md-table-cell>
					        <md-table-cell md-label="小程序名称" width="130px"><div style="width:120px; color: cornflowerblue;"  @click="editRule(item)">{{ item.name }}</div></md-table-cell>
					        <md-table-cell md-label="appid" >{{item.appid}}</md-table-cell>
					        <md-table-cell md-label="功能点"  > 
					        	<div v-for="(value, key) in item.rule" style="width:200px">
						          	<span v-for="(val,k,i) in value" v-if="k=='rule'">
						          		<span  class="gn" v-for="cit,cid in val" >{{cit.name}},</span>
						          	</span>
						          </div>
					        </md-table-cell>
					        <md-table-cell md-label="激活状态">
					        	
					        	<md-button class="md-raised " :class="item.status=='1'?'md-primary':'md-accent'"  @click="changeStatus(true,item)">{{item.status=='1'?'正常':'禁用'}}</md-button>
					        </md-table-cell>
					        <md-table-cell md-label="操作" >
					        	<div style="width:50px">
						        	<md-button size="medium" type="primary" @click="editRule(item)">编辑</md-button>
						        </div>
					        </md-table-cell>
					        
					    </md-table-row>
			     	</md-table>
					    
			    	<md-table  v-else>
				      <md-table-row>
				        <md-table-head>暂无信息</md-table-head>
				      </md-table-row>
					</md-table>
		    	</div> 
		    </div> 	
		    
		    <div class="md-layout md-gutter"> 
		    	<h3 class="md-layout-item md-xsmall-size-100">扣量策略</h3>
		     	
		     	 <div class="md-layout md-gutter">
							<div class="md-layout-item md-xsmall-size-25">
								<md-button class="md-raised" @click.native="addALDProduct">新增</md-button>
							</div>
							<div class="md-layout-item md-xsmall-size-25">
								<md-button class="md-raised md-primary" @click="changeALDStatus(false,1)">启用</md-button>
							</div>
							<div class="md-layout-item md-xsmall-size-25">
								<md-button class="md-raised md-accent"  @click="changeALDStatus(false,0)">禁用</md-button>
							</div>
			    		</div>
				     	<div class="md-layout-item md-xsmall-size-100">
					     	<md-table v-model="klist" v-if="klist.length>0"  @md-selected="onKSelect"> 
								
						     	<md-table-row  slot="md-table-row" slot-scope="{ item }"  md-selectable="multiple" md-auto-select>
							        <md-table-cell md-label="ID" md-numeric>{{ item.id }}</md-table-cell>
							        <md-table-cell md-label="小程序名称"><div style="width:120px;color: cornflowerblue;" @click="$router.push({name:'扣量规则详情',params:{index_id:item.id}})"> {{item.name}}</div></md-table-cell>
							        <md-table-cell md-label="扣量比例" >{{item.pr}}</md-table-cell>
							        <md-table-cell md-label="原始阿拉丁key" >{{item.ald_key}}</md-table-cell>
							        <md-table-cell md-label="激活状态"><md-button class="md-raised " :class="item.status=='1'?'md-primary':'md-accent'"  @click="changeALDStatus(true,item)">{{item.status=='1'?'正常':'禁用'}}</md-button></md-table-cell>
							        <md-table-cell md-label="操作" >
							        	<md-button size="medium" type="primary" @click="editALDRule(item)">编辑</md-button>
							        </md-table-cell>
							        
							    </md-table-row>
					     	</md-table>
					     	<md-table  v-else>
						      <md-table-row>
						        <md-table-head>暂无信息</md-table-head>
						      </md-table-row>
							</md-table>
					    </div>
			    </div> 	
		    
		    
		    
		  <md-dialog class="editDialog" :md-active.sync="editDialog">
			
		  <form novalidate  @submit.prevent="validateUser">
		  <md-content style="padding: 10px;">
	      <md-dialog-title>{{isAdd==true?"新增屏蔽策略":"编辑屏蔽策略"}}</md-dialog-title>
	     
		  <div class="md-layout md-gutter md-alignment-center">
		  	
		  	<div class="md-layout-item md-medium-size-100 md-small-size-100 md-xsmall-size-100">
		  	    <md-tabs>
			      <md-tab :id="key" :md-label="key" v-for="(value, key, idx) in chooseProduct">
			      	 <div class="md-layout md-gutter"> 
			      		<div class="md-layout-item md-xsmall-size-100">
					      	<md-field>
						      <label>{{'请输入'+key+'平台的APPID'}}</label>
						      <md-input v-model="value.appid" :disabled="key=='weixin'?true:false"></md-input>
						    </md-field>
				       </div>
				       <h3 class="md-layout-item md-xsmall-size-100">SDK配置</h3>
				       <div class="md-layout-item md-xsmall-size-100">
					      	<md-field>
						      <label>审核版本号</label>
						      <md-input v-model="value.sdk.review_ver"  placeholder="审核版本号"  @input="inputCG()"></md-input>
						    </md-field>
				       </div>
				       <div class="md-layout-item md-xsmall-size-100">
					      	<md-field>
						      <label>屏蔽城市</label>
						      <md-input v-model="value.sdk.valid_ad_city"  placeholder="屏蔽城市"  @input="inputCG()"></md-input>
						    </md-field>
				       </div>
				       <div class="md-layout-item md-xsmall-size-100">
					      	<md-field>
						      <label>路径</label>
						      <md-input v-model="value.sdk.path"  placeholder="路径"  @input="inputCG()"></md-input>
						    </md-field>
				       </div>
				      
				       <div class="md-layout-item md-xsmall-size-60">
					      	<md-field>
						      <label>名单</label>
						      <md-input v-if="value.sdk.isWhite"  v-model="value.sdk.valid_ad_scene_white" placeholder="白名单" @input="inputCG()"></md-input>
							  <md-input v-else  v-model="value.sdk.valid_ad_scene_black" placeholder="黑名单" @input="inputCG()"></md-input>
						    </md-field>
				       </div>
				        <div class="md-layout-item md-xsmall-size-40">
				        	<md-switch v-model="value.sdk.isWhite" @change="valid_adWhiteChange(value,idx,key)">{{value.sdk.isWhite==true?'白名单':'黑名单'}}</md-switch>
				        </div>
				        
				        <h3 class="md-layout-item md-xsmall-size-100">屏蔽规则</h3>
				        <div class="md-layout-item md-xsmall-size-100">
				       		<div class="md-layout md-gutter "  v-for="(item,index) in value.rule" prop="rule">
				       	
				        	 	<div class="md-layout-item md-xsmall-size-30">
				        	 		<md-switch v-model="item.status" >{{item.status==true?'启用':'禁用'}}</md-switch>
				        	 	</div>
				        	 	<div class="md-layout-item md-xsmall-size-70">
							      	<md-field>
								      <label>序号</label>
								      <md-input v-model="item.no"  placeholder="序号"  @input="inputCG()"></md-input>
								    </md-field>
						        </div>
						        <div class="md-layout-item md-xsmall-size-100">
							      	<md-field>
								      <label>规则名称</label>
								      <md-input v-model="item.name"  placeholder="规则名称"  @input="inputCG()"></md-input>
								    </md-field>
						        </div>
						        <div class="md-layout-item md-xsmall-size-100">
							      	<md-field>
								      <label>屏蔽城市</label>
								      <md-input v-model="item.city"  placeholder="屏蔽城市"  @input="inputCG()"></md-input>
								    </md-field>
						        </div>
						        <div class="md-layout-item md-xsmall-size-60">
							      	<md-field>
								      <label>白名单</label>
								      <md-input v-if="item.isWhite"  v-model="item.scene_white" placeholder="白名单" @input="inputCG()"></md-input>
									  <md-input v-else  v-model="item.scene_black" placeholder="黑名单" @input="inputCG()"></md-input>
								    </md-field>
						       </div>
						       <div class="md-layout-item md-xsmall-size-40">
				        	 		<md-switch v-model="item.isWhite" @change="whiteChange(value,index,key)">{{item.isWhite==true?'白名单':'黑名单'}}</md-switch>
				        	 	</div>
				        	 	
				        	 	 <div class="md-layout-item md-xsmall-size-100">
							      	<md-field>
								      <label>路径</label>
								      <md-input v-model="item.path_black"  placeholder="路径"  @input="inputCG()"></md-input>
								    </md-field>
						        </div>
						        
						         <div class="md-layout-item md-xsmall-size-100">
							      	<md-field>
								      <label>次数</label>
								      <md-input v-model="item.show_num"  placeholder="次数"  @input="inputCG()"></md-input>
								    </md-field>
						        </div>
						        
						         <div class="md-layout-item md-xsmall-size-100">
							      	<md-field>
								      <label>概率</label>
								      <md-input v-model="item.show_per"  placeholder="概率"  @input="inputCG()"></md-input>
								    </md-field>
						        </div>
						        <div class="md-layout-item md-xsmall-size-50">
										<md-button class="md-raised md-primary"  @click="addRules(index,key)">+</md-button>
	
						        </div>
						        <div class="md-layout-item md-xsmall-size-50">
										<md-button class="md-raised md-accent" v-if="value.rule.length>1"  @click="removeRules(value,index,key)">-</md-button>
								</div>
					        
					        
					       
				        	</div>
				        </div>
				         
				     </div>   
				    
				       
			      </md-tab>
			     <!-- <md-tab id="tab-pages-2" md-label="Pages 2" >Subpage 2</md-tab>-->
			    </md-tabs>
		  	    
		  	</div>
		  	
		  
		  	
		  
		  	
		 
	       
		  </div>
		  
		  <md-progress-bar md-mode="indeterminate" v-if="sending" />
	      <md-dialog-actions>
	        <md-button class="md-primary" @click="editDialog = false">取消</md-button>
	        <md-button type="submit" class="md-primary" :disabled="sending">保存</md-button>
	        <!--<md-button class="md-primary" type="submit" :disabled="sending">保存</md-button>-->
	      </md-dialog-actions>
	       </md-content>
	       </form>
	    </md-dialog>
	
		 
		  <md-dialog class="editDialog" :md-active.sync="editALDDialog">
			
		  <form novalidate  @submit.prevent="validALDUser">
		  <md-content style="padding: 10px;">
	      <md-dialog-title>{{isAdd==true?"新增扣量策略":"编辑扣量策略"}}</md-dialog-title>
	     
		  <div class="md-layout md-gutter md-alignment-center">
		  	
		  	<div class="md-layout-item md-medium-size-100 md-small-size-100 md-xsmall-size-100">
		  		 <div class="md-layout-item md-xsmall-size-100">
			      	<md-field>
				      <label>默认扣量</label>
				      <md-input v-model="chooseALDProduct.pr"  placeholder="请输入扣量"  @input="inputCG()"></md-input>
				    </md-field>
		        </div>
		        <div class="md-layout-item md-xsmall-size-100">
			      	<md-field>
				      <label>原始ALDKEY</label>
				      <md-input v-model="chooseALDProduct.ald_key"  placeholder="请输入key"  @input="inputCG()"></md-input>
				    </md-field>
		        </div>
			</div>
		  </div>
		  
		  <md-progress-bar md-mode="indeterminate" v-if="sending" />
	      <md-dialog-actions>
	        <md-button class="md-primary" @click="editALDDialog = false">取消</md-button>
	        <md-button type="submit" class="md-primary" :disabled="sending">保存</md-button>
	        <!--<md-button class="md-primary" type="submit" :disabled="sending">保存</md-button>-->
	      </md-dialog-actions>
	       </md-content>
	       </form>
	    </md-dialog>
		    
		    
		</md-content>
		
		   <md-dialog-alert
	      :md-active.sync="isSuc"
	      :md-content="successMessage"
	      md-confirm-text="知道了!" />
	      
	      <md-dialog-alert
	      :md-active.sync="isErr"
	      :md-content="ErrorMessage"
	      md-confirm-text="知道了!" />
	      
	      
	</div>
</template>

<script>
	import parse from 'date-fns/parse'
  	import format from 'date-fns/format'
  	import isValid from 'date-fns/isValid'
	import {sc2data2,rulesList,rulesAldList,ruleStatus,aldStatus,rulesAdd,rulesEdit,rulesAldAdd,rulesAldEdit } from "../api/api";
	export default {
		 data() {
		 	let dateFormat = this.$material.locale.dateFormat || 'yyyy-MM-dd'
      		let now = new Date(new Date().getTime() - 3600 * 1000 *30);
      		let history = new Date(new Date().getTime() - 3600 * 1000 *30);
		 	return{
		 		 pdata: {
			        page: 1,
			        perpage: 20,
			        type: "",
			        kw: "",
			        issued_app_name:"",
			        product_name:"",
			        creative_name:"",
			        sdate: format(history, dateFormat),
			        edate: format(now, dateFormat),
			      },
			      cyPdata:{
			        page: 1,
			        perpage: 20,
			        type: "",
			        kw: "",
			        issued_app_name:"",
			        product_name:"",
			        creative_name:"",
			        sdate: format(history, dateFormat),
			        edate: format(now, dateFormat),
			      },
			      rPdata:{
			        page: 1,
			        perpage: 20,
			        type: "",
			        kw: "",
			        issued_app_name:"",
			        product_name:"",
			        creative_name:"",
			        sdate: format(history, dateFormat),
			        edate: format(now, dateFormat),
			      },
	
			      
	
			      maxPage:1,
			      c2data: { total: {}, chat: {}, list: [], max_page: 1},
			      pText:"请选择产品投放位置",
			      option: [],//投放位置配置
			      rlist:[],
			      klist:[],
				  Rselected:[],
				  Kselected:[],
				  editDialog:false,
				  editALDDialog:false,
				  
				  chooseProduct: {
			      	"weixin":{
						"appid":"",
			        	"sdk":{
					     		"review_ver":'',
								"path":'',
								"valid_ad_city":'',
								"valid_ad_scene_white":'',
								"valid_ad_scene_black":'',
					      	},
					      	"rule":[{status:true, no:'',name:'',city:'',scene_black:'',scene_white:'',isWhite:false,path_black:'',show_num:'',show_per:''}]
							}
				  },
				  chooseALDProduct:{ 
					  "issued_app_id": "",
				      "pr":"", 
					  "ald_key":""
				  },
				  applist:[],
				  issued_app_id:'',
	  			  index_id:'',
	  			  isAdd: false,
	  			  isADLAdd:false,
	  			  sending:false,
	  			  get_shield_rule_platform:[],
	  			  isSuc:false,
			      isErr:false,
			      successMessage:'',
			      ErrorMessage:'',
			      RcP: {
			        index_id: "",
			        status: "1",
			        log: ""
			      }, //修改选中的产品状态,批量修改状态
			      KcP: {
			        index_id: "",
			        status: "1",
			        log: ""
			      }, //修改选中的产品状态,批量修改状态
			 	}
		 	  
		 },
		  validations: {
	     
	      },
		   watch: {
		    "pdata.sdate": {
		      handler(n, o) {
		        this.pdata.sdate=n;
		        this.cyPdata.sdate=n;
		        this.pdata.page=1;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    },
		     "pdata.edate": {
		      handler(n, o) {
		        this.pdata.sdate=n;
		        this.cyPdata.edate=n;
		        this.pdata.page=1;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    },
		    "pdata.issued_app_name": {
		      handler(n, o) {
		        this.pdata.issued_app_name=n;

		        this.pdata.page=1;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    },
		    "pdata.page": {
		      handler(n, o) {
		        this.pdata.page=n;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    },
		    
		    "cyPdata.page": {
		      handler(n, o) {
		        this.cyPdata.page=n;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    }
		  },
		 methods:{
		 	goBack(){
		 		this.$router.go(-1);
		 	},
		 	inputCG(){
  		
		  		this.$forceUpdate();
		  	},
		  	whiteChange(value,index,key){
  		
				if(this.chooseProduct[key].rule[index].isWhite==true){
		      	 this.chooseProduct[key].rule[index].scene_black='';
		      	}
		      	else{
		      		this.chooseProduct[key].rule[index].scene_white='';
		      	}
				console.log('change',this.chooseProduct[key].rule);
		  		
				this.$forceUpdate();
		  	},
		  	valid_adWhiteChange(value,idx,key){
		  
					if(this.chooseProduct[key].sdk.isWhite==true){
						 this.chooseProduct[key].sdk.valid_ad_scene_black='';
					}
					else{
							this.chooseProduct[key].sdk.valid_ad_scene_white='';
					}
					console.log('valid_adWhiteChangechange',this.chooseProduct[key]);
		  		this.$forceUpdate();
		  	},
		 	getValidationClass (fieldName) {
		        const field = this.$v[fieldName]
		        if (field) {
		          return {
		            'md-invalid': field.$invalid && field.$dirty
		          }
		        }
		      },
		 	changeIssued(item){
		  		this.chooseProduct['weixin'].appid=item.appid;
		  		this.$forceUpdate();
		  	},
		  	addRules(index,key){
				var o={status:true, no:'',name:'',city:'',scene_black:'',scene_white:'',isWhite:false,path_black:'',show_num:'',show_per:''};
				this.chooseProduct[key].rule.push(o);
				this.$forceUpdate();
		  	},
		  	removeRules(value,index,key){
		  		this.chooseProduct[key].rule.splice(index,1); 
		  		this.$forceUpdate();
		  		
		  	},
		 	onRSelect (items) {
		 		
		        this.Rselected = items;
		        var arr=[];
		        this.Rselected.forEach((v,i)=>{
		        	arr.push(v.id)
		        	
		        })
		        this.RcP.index_id=arr.toString();
		        
		    },
		    onKSelect (items) {
		        this.Kselected = items;
		        var arr=[];
		        this.Kselected.forEach((v,i)=>{
		        	arr.push(v.id)
		        })
		        this.KcP.index_id=arr.toString();
		    },
		 	tabChange(){
		 		console.log('tabbbbbbbbbbbbbbbbbb')
		 	},
		 	goDetail(id){
		 		this.$router.push({ path: '/product/detail/'+id })
		 	},
		 	getList() {
			      var p = "";
			      this.cyPdata=this.pdata;
			      this.cyPdata.kw=this.pdata.issued_app_name;
			      for (var k in this.cyPdata) {
			        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
			        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
			      }

			      sc2data2(p, this.$cookie.getCookie("login")).then(res => {
			        if (res.code == 200) {
			          if (res.data.list!=null&&res.data.list.length > 0) {
			           res.data.list.forEach((x,i) => {
				            	x.keyid='key'+i;
				              x.exData = [];
				            });
			            this.c2data = res.data;
			
			          }
			          else{
			          	this.c2data = res.data;
			          	this.c2data.list = [];
			
			          }
			        }
			      });
			      
			      var p = "";
			      for (var k in this.rPdata) {
			        if (this.rPdata[k]) p += k + "=" + this.rPdata[k] + "&";
			      }
			      rulesList(p, this.$cookie.getCookie("login")).then(res => {
			        if (res.code == 200) {
			        	  if (res.data.list!=null&&res.data.list.length > 0) {
					          this.rlist = res.data.list;
					          this.getConfig();
				          }
			        }
			      });
			      
			     
			      
			    rulesAldList(p, this.$cookie.getCookie("login")).then(res => {
			        if (res.code == 200) {
			        	if (res.data.list!=null&&res.data.list.length > 0) {
				          this.klist = res.data.list;
				         }
			        }
			    });
			   
			},
			changeStatus(isSingle, s) {
		      if (!isSingle && this.Rselected.length == 0) {
		        //this.$message.error("请先选择需要批量操作的数据");
		        this.isErr=true;			     
			    this.ErrorMessage='请先选择需要批量操作的数据';
		        return;
		      }
		      if (isSingle) {
		        this.RcP.index_id = s.id;
		        this.RcP.status = s.status == 1 ? "0" : "1";
		      } else {
		        this.RcP.status = s;
		      }
		
		      if (this.RcP.status == 0) {
		        this.RcP.log = "禁用产品";
		      } else if (this.RcP.status == 1) {
		        this.RcP.log = "启用产品";
		      } else if (this.RcP.status == -1) {
		        this.RcP.log = "删除产品";
		      }
		      ruleStatus(this.RcP, this.$cookie.getCookie("login")).then(res => {
		        if (res.code == 200) {
		          this.getList();
		          this.isSuc=true;
		          this.successMessage='成功';
		          
		        }
		      });
		    },
		    changeALDStatus(isSingle, s) {
		      if (!isSingle && this.Kselected.length == 0) {
		        //this.$message.error("请先选择需要批量操作的数据");
		        this.isErr=true;			     
			    this.ErrorMessage='请先选择需要批量操作的数据';
		        return;
		      }
		      if (isSingle) {
		        this.KcP.index_id = s.id;
		        this.KcP.status = s.status == 1 ? "0" : "1";
		      } else {
		        this.KcP.status = s;
		      }
		
		      if (this.KcP.status == 0) {
		        this.KcP.log = "禁用产品";
		      } else if (this.KcP.status == 1) {
		        this.KcP.log = "启用产品";
		      } else if (this.KcP.status == -1) {
		        this.KcP.log = "删除产品";
		      }

		      aldStatus(this.KcP, this.$cookie.getCookie("login")).then(res => {
		        if (res.code == 200) {
		          this.getList();
		          this.isSuc=true;
		          this.successMessage='成功';
		        }
		      });
		    },
			editRule(d) {
			      this.editDialog = true;
			  
			      this.get_shield_rule_platform.forEach((v,i)=>{
			        	   var o={
					        	"appid":"",
					        	"sdk":{
							     		"review_ver":'',
											"path":'',
											"valid_ad_city":'',
											"valid_ad_scene_white":'',
											"valid_ad_scene_black":'',
							      	},
							      	"rule":[{status:true, no:'',name:'',city:'',scene_black:'',scene_white:'',isWhite:false,path_black:'',show_num:'',show_per:''}]
						      };
						      
						      this.chooseProduct[v]=o;
						      
			        })
			      this.chooseProduct['weixin'].appid=this.rlist[0].appid;
			      this.index_id=d.id;
			      
			      var rule =d.rule;
			      for(var i in rule){
			      	this.chooseProduct[i]=rule[i];
			      	if(this.chooseProduct[i].sdk.valid_ad_scene_white!=''){
				      	 this.chooseProduct[i].sdk.isWhite=true;
				      	 this.chooseProduct[i].sdk.valid_ad_scene_black=''
				      }
				      else{
				      	this.chooseProduct[i].sdk.isWhite=false;
				      }
				      	this.chooseProduct[i].rule.forEach((v,i)=>{
				      	if(v.scene_white!=''){
				      		v.isWhite=true;
				      		v.scene_black='';
				      	}
				      	else{
				      		v.isWhite=false;
				      		v.scene_white='';
				      	}
				      	if(v.status&&v.status==1){
				      			v.status=true;
				      	}
				      	else{
				      		v.status=false;
				      	}
				      })
			      }
			      this.isAdd = false;
			},
			addProduct() {
		       this.get_shield_rule_platform.forEach((v,i)=>{
		        	   var o={
				        	"appid":"",
				        	"sdk":{
						     		"review_ver":'',
									"path":'',
									"valid_ad_city":'',
									"valid_ad_scene_white":'',
									"valid_ad_scene_black":'',
						      	},
						      	"rule":[{status:true, no:'',name:'',city:'',scene_black:'',scene_white:'',isWhite:false,path_black:'',show_num:'',show_per:''}]
					      };
					      this.chooseProduct[v]=o;
					      
		        })
		      this.chooseProduct['weixin'].appid=this.rlist[0].appid;
		      this.editDialog = true;
		      this.isAdd = true;
		    },
		    //增加扣量规则
		    addALDProduct(){
		    	this.chooseALDProduct={
			      "issued_app_id": "",
			      "pr":"", 
				  "ald_key":""
				};
			    this.editALDDialog = true;
			    this.isADLAdd = true;
		    },
		    editALDRule(d) {
		      this.editALDDialog = true;
		      this.chooseALDProduct = JSON.parse(JSON.stringify(d));
		      this.chooseALDProduct.index_id=d.id;
		      delete this.chooseALDProduct.create_time;
		      this.isAdd = false;
		    },
		    submit() {
		    	
		    	for(var i in this.chooseProduct){
			    		if(this.chooseProduct[i].appid==''){
    						debugger;
			    			delete this.chooseProduct[i];
			    			continue;
						  }
			    		
					   	var rule=this.chooseProduct[i].rule;
					   	rule.forEach((vv,ii)=>{
							if(vv.status){
								vv.status=1;
							}
							else{
								vv.status=0;
							}
						})
					}	
		//    this.$refs.ruleForm.validate(valid => {
		//      if (valid) {
		          if (this.isAdd) {
							
		          	var p ={
		          		"issued_app_id":this.issued_app_id,
		          		"rule":encodeURIComponent(JSON.stringify(this.chooseProduct)),
		          	}
		          	console.log(p);
		            rulesAdd(p, this.$cookie.getCookie("login")).then(
		              res => {
		                if (res.code == 200) {
		                  this.isSuc=true;
		         		  this.successMessage='成功';
		                  this.getList();
		                  this.editDialog = false;
		                } else {
	
			                this.isErr=true;			     
				    		this.ErrorMessage=res.msg
		                }
		              }
		            );
		          } else {
			//          this.$prompt("请输入编辑原因", "提示", {
			//            confirmButtonText: "确定",
			//            cancelButtonText: "取消",
			//            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
			//            inputErrorMessage: "内容不能为空"
			//          }).then(({ value }) => {
			              //this.chooseProduct.log = value;
			              	var p ={
					          		"issued_app_id":this.issued_app_id,
					          		"rule":encodeURIComponent(JSON.stringify(this.chooseProduct)),
					          		"index_id":this.index_id,
					          	}
			              rulesEdit(p, this.$cookie.getCookie("login")).then(
			                res => {
			                  if (res.code == 200) {
			                    this.getList();
			                    this.editDialog = false;
			                    this.isSuc=true;
		         		  		this.successMessage='成功';
			                  } else {
			                    this.isErr=true;			     
				    			this.ErrorMessage=res.msg
			                  }
			                }
			              );
			//          });
			          }
			//      }
			//      else {
			//        return false;
			//      }
			//    });
		    },
		    ALDsubmit() {
		    	
//		      this.$refs.ruleForm.validate(valid => {
//		        if (valid) {
		          if (this.isALDAdd) {
		          	var p ={
		          		"issued_app_id":this.issued_app_id,
		  		     	"pr":this.chooseALDProduct.pr,
						"ald_key":this.chooseALDProduct.ald_key,
		          	}
		            rulesAldAdd(p, this.$cookie.getCookie("login")).then(
		              res => {
		                if (res.code == 200) {
	                	  this.isSuc=true;
	         		  	  this.successMessage='成功';
		                  this.getList();
		                  this.editALDDialog = false;
		                } else {
		                  this.isErr=true;			     
				    	  this.ErrorMessage=res.msg
		                }
		              }
		            );
		          } else {

		              	var p ={
				          		"issued_app_id":this.issued_app_id,
				          		"pr":this.chooseALDProduct.pr,
								"ald_key":this.chooseALDProduct.ald_key,
				          		"index_id":this.chooseALDProduct.index_id,
				          	}
		              rulesAldEdit(p, this.$cookie.getCookie("login")).then(
		                res => {
		                  if (res.code == 200) {
		                    this.getList();
		                    this.isSuc=true;
	         		  	    this.successMessage='成功';
		                    this.editALDDialog = false;
		                  } else {
		                    this.isErr=true;			     
				    		this.ErrorMessage=res.msg
		                  }
		                }
		              );
		//          });
		          }
//		        } else {
//		          return false;
//		        }
//		      });
		    },
					
			
			 getConfig() {
		      if (this.$store.config) {
		        this.config = this.$store.config.product_theme;
		        this.tags = this.$store.config.product_tag;
		        this.option = this.$store.config.product_placement;
		        this.applist = this.$store.applist;
		        this.get_shield_rule_platform = this.$store.config.get_shield_rule_platform;
		        this.get_shield_rule_platform.forEach((v,i)=>{
		        	   var o={
				        	"appid":"",
				        	"sdk":{
						     		"review_ver":'',
										"path":'',
										"valid_ad_city":'',
										"valid_ad_scene_white":'',
										"valid_ad_scene_black":'',
						      	},
						      	"rule":[{status:true, no:'',name:'',city:'',scene_black:'',scene_white:'',isWhite:false,path_black:'',show_num:'',show_per:''}]
					      };
					      this.chooseProduct[v]=o;
					      
		        });
		        this.chooseProduct['weixin'].appid=this.rlist[0].appid;
		        
		        this.applist.forEach((v,i)=>{
		        	if(this.chooseProduct['weixin'].appid==v.appid){
		        		this.issued_app_id=v.id
		        	}
		        })
		        
		      } else {
		        setTimeout(() => {
		          this.getConfig();
		        }, 50);
		      }
		    },
		    clearPlacement(s){
		    	this.pdata.placement = '';
		    },
		    validateUser () {

		        this.$v.$touch()
				
		        if (!this.$v.$invalid) {
		          console.log('保存');
		          this.submit();
		        }
		    },
		    validALDUser(){
		    	this.$v.$touch()
				
		        if (!this.$v.$invalid) {
		          console.log('保存');
		          this.ALDsubmit();
		        }
		    },
		 },
		 mounted() {
		 	this.pdata.issued_app_name = this.$route.params.name;
		 	this.rPdata.kw = this.$route.params.name;
		    this.getList();
		   
		 }
		 
	}
</script>

<style>
	.md-table-cell-container table{
		padding: 0;
	}
	.md-button{
		min-width: 66px;
	}
	.md-table-cell-container,.md-table-head-label{
		padding: 6px 15px;
	}
	.md-dialog-container{
		width: 100%;
	}
	.editDialog{
		width: 100%;
		height: 100%;
		overflow-y: scroll;
	}
</style>


// WEBPACK FOOTER //
// detail.vue?06fa551e